import { createAction } from '@reduxjs/toolkit';
export const LOAD_AUDIO_DEVICE = 'LOAD_AUDIO_DEVICE';
export const loadAudioDeviceAction = createAction(LOAD_AUDIO_DEVICE);